import { Component, OnInit, HostListener } from '@angular/core';
import { PetsService } from "../../_services";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { Meta, Title } from "@angular/platform-browser";
import { ShareService } from "@ngx-share/core";
import { DialogComponent } from '..//../pets/dialog/dialog.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService , FacebookLoginProvider, GoogleLoginProvider} from "angularx-social-login";
import {
  FacebookService,
  UIParams,
  UIResponse,
  InitParams,
} from "ngx-facebook";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { of } from 'rxjs';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-details2',
  templateUrl: './details2.component.html',
  styleUrls: ['./details2.component.scss']
})


export class Details2Component implements OnInit {
  pageType: string;
  public lat: number;
  public lng: number;
  public zoom: number;
  public showhideBackButton: boolean;
  public showhomePageBrowseListing: boolean;
  public petType: string = "current";
  public isPreviousDisabled: boolean = false;
  public isNextDisabled: boolean = false;
  public showNextPrev: boolean = false;
  public qrCodeString: string = "";
  public currentUser: any = null;
  public petName = "";
  public calledFrom = "";
  public operationTypeID: string = "";
  public searchFilters: any = null;
  public petChipID: string = "";

  public petAddress = "";
  public queryParams: any;
  public Url_PetId: any;
  public Url_ChipId: any;
  public isHidden: boolean = true;
  public currentUserId: number;
  public showReunitePetButton: boolean;
  public alreadyReunite: boolean;
  public showPrintButton: boolean;
  petLostFoundId: any = 0;
  FBUserid = "";
  shortToken = "";
  public isAgeInMonth: boolean = false;
  public styles: any = [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }]
  constructor(
    private Pets: PetsService,
    private router: ActivatedRoute,
    private meta: Meta,
    private title: Title,
    private routeObj: Router,
    public share: ShareService,
    private fb: FacebookService,
    public dialog: MatDialog,
    private authService: AuthService
  ) {
    this.qrCodeString = window.location.href;
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    // localStorage.setItem('backbutton', "1");

  }

  //petImagePath = environment.apiBaseUrl + "/Static/Images/";
  public LostFoundPetID: any;
  public pet: any;
  public reunitepet: any;
  detailMessageString =
    environment.lostFoundBaseUrl + "dashboard/pet-detail?PetID=";
  detailMessageStringEMail =
    "Les mer : " + environment.lostFoundBaseUrl + "dashboard/pet-detail?PetID=";
  ShareMessage: string;
  public petListany: any = [];
  public printPetUrl = "";

  public IsNeighbourPet = false;

  ngOnInit(): void {

    let encryptedPetId = this.router.snapshot.paramMap.get("id");
    let paramObject;
    if (encryptedPetId && encryptedPetId != undefined && encryptedPetId != '') {
      paramObject = JSON.parse(atob(encryptedPetId));
      if (paramObject.hasOwnProperty("PetID")) {
        this.Url_PetId = paramObject["PetID"];
        this.LostFoundPetID = paramObject["PetID"];
        localStorage.setItem("LostFoundPetID", this.LostFoundPetID);
        localStorage.setItem("OperationTypeID", paramObject["OperationTypeId"]);
        localStorage.setItem("Url_PetId", this.Url_PetId);
      }

      if (paramObject.hasOwnProperty("ChipID")) {
        this.Url_ChipId = paramObject["ChipID"];
        localStorage.setItem("OperationTypeID", paramObject["OperationTypeId"]);
        localStorage.setItem("Url_ChipId", this.Url_ChipId);
        this.LostFoundPetID = localStorage.getItem("LostFoundPetID");
      }
    }
    else {
      this.Url_PetId = localStorage.getItem("Url_PetId");  // Against of queryParams
      this.Url_ChipId = localStorage.getItem("Url_ChipId");
      this.LostFoundPetID = localStorage.getItem("LostFoundPetID");
    }


    this.pageType = this.router.snapshot.paramMap.get("type");
    this.scrollTop()
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.calledFrom = localStorage.getItem("_calledFrom");
    this.searchFilters = JSON.parse(localStorage.getItem("SearchFilters"));
    this.petChipID = localStorage.getItem("pet_ChipID");

    if (this.calledFrom == "home") {
      this.showhomePageBrowseListing = true;
    } else {
      this.showhomePageBrowseListing = false;
    }

    const page = localStorage.getItem("_page");
    if (page && page === "dashboard") {
      this.getmyReportedPets();
    }
    else {
      this.petListany = this.Pets.fetchListData();
    }

    this.getPetDetails();
    this.showhideBackButton = true;
    var currenturl = window.location.href;
    // if(currenturl.toLowerCase().indexOf('report-lost') > 0 || currenturl.toLocaleLowerCase().indexOf('report-found') > 0 ||  currenturl.toLocaleLowerCase().indexOf('dashboard') > 0 ){
    if (
      currenturl.toLowerCase().indexOf("report-lost") > 0 ||
      currenturl.toLocaleLowerCase().indexOf("report-found") > 0
    ) {
      this.showhideBackButton = false;
    }
    this.ShareMessage = "";
  }

  /** this method will get my reported pet and
   *  will call if user are coming from my reported pet page
  */
  getmyReportedPets() {
    let operationTypeId = localStorage.getItem("OperationTypeID");
    this.scrollTop();
    let filters = {
      "StartIndex": 0,
      "EndIndex": 1000,
      "UserId": this.currentUser.ID,
      "ListType": operationTypeId,
      "Company": this.currentUser.Company
    }
    this.Pets.GetLostFoundPetsListByUser(filters).subscribe(response => {
      this.petListany = response.data;
    });
  }

  getPetDetails = () => {
    this.isPreviousDisabled = false;
    this.isNextDisabled = false;
    this.showNextPrev = true;
    const page = localStorage.getItem("_page");
    const userId = page && page === "dashboard" ? this.currentUser.ID : "";

    let currentIndex = 0;
    if (this.petType == "next") {
      currentIndex = this.petListany.findIndex(item => item.LostFoundID == parseInt(this.LostFoundPetID));
      if (currentIndex == this.petListany.length - 1) {
        this.isNextDisabled = true;
        return;
      }
      let nextPet = this.petListany[currentIndex + 1];
      this.goToDetails(nextPet);
    } else if (this.petType == "previous") {
      currentIndex = this.petListany.findIndex(item => item.LostFoundID == parseInt(this.LostFoundPetID));
      if (currentIndex == 0) {
        this.isPreviousDisabled = true;
        return;
      }
      let previousPet = this.petListany[currentIndex - 1];
      this.goToDetails(previousPet);
    }

    let parameters: any = {
      userId: userId,
      LostFoundPetID: parseInt(localStorage.getItem("LostFoundPetID")),
      type: 'current',
      OperationTypeID: localStorage.getItem("OperationTypeID"),
    };

    if (page && page === "list_page") {
      parameters.lat = this.searchFilters?.lat;
      parameters.lng = this.searchFilters?.lng;
      parameters.radiousDistance = this.searchFilters?.radiousDistance;
      parameters.BreedID = this.searchFilters?.BreedID;
      parameters.SpeciesID = this.searchFilters?.SpeciesID;
      parameters.page = "";
    } else {
      parameters.lat = 59.9138688;
      parameters.lng = 10.7522454;
      parameters.radiousDistance = "";
      parameters.BreedID = "";
      parameters.SpeciesID = "";
      parameters.page = "";
    }
    this.queryParams = this.router.snapshot.queryParams;
    if (this.petListany && this.petListany.length == 1) {
      this.showNextPrev = false;
    }
    this.Url_PetId = localStorage.getItem("Url_PetId");  // Against of queryParams
    this.Url_ChipId = localStorage.getItem("Url_ChipId");
    this.alreadyReunite = true;

    if (this.Url_ChipId) {
      this.Pets.getChipInfo(this.Url_ChipId).subscribe((response) => {
        let IsNeighbourPetValue;

        if (response) {
          this.pet = response;
          this.pet.IsNeighbourPet = true;
          this.pet.MasterBreed = response.Breed;
          this.pet.MasterSpecies = response.Species;
          this.pet.Company = response.ClinicName;
          this.pet.ZipCode = response.PostalCode;
          this.pet.AdditionalInfo = response?.AdditionalInfo?.replace(/(<([^>]+)>)/gi, "");
          this.qrCodeString = window.location.href;

          var dob = null;
          let currentDate = new Date();
          var age = 0;
          this.isAgeInMonth = false;
          if (!response.Age) {
            if (response.BirthYear && response.BirthMonth && response.BirthDate) {
              let birthMonth = response.BirthMonth == 0 ? 11 : response.BirthMonth - 1;
              let birthYear = response.BirthMonth == 0 ? response.BirthYear - 1 : response.BirthYear;
              dob = new Date(birthYear, birthMonth, response.BirthDate);
              var diff = Math.abs(currentDate.getTime() - dob.getTime());
              var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
              if (diffDays > 364) {
                age = Math.round(diffDays / 365);
              }
              else {
                let month = Math.round(diffDays / 30); // getting the month 
                let ageInYear = month / 12; // getting the year
                if (ageInYear < 1) { // if year less than one show the month otherwise showing the year
                  age = month;
                  this.isAgeInMonth = true;
                }
                else {
                  age = Math.round(ageInYear);
                }
              }
            }
          }
          else {
            let ageInYear = response.Age / 12;
            if (ageInYear < 1) {
              age = response.Age;
              this.isAgeInMonth = true;
            }
            else {
              age = Math.round(response.Age / 12);
            }
          }

          this.pet.Age = age;
          this.lat = Number(parameters.lat);
          this.lng = Number(parameters.lng);
          this.zoom = 15;
          let subtext = "";
          if (response && response.OperationTypeID == 1) {
            subtext = "Tapt";
          } else if (response && response.OperationTypeID == 2) {
            subtext = "Funnet";
          }

          // let HairType ='';
          if (response.HairType == 1) {
            this.pet.HairType = "Langhåret";
          } else if (response.HairType == 2) {
            this.pet.HairType = "Korthåret";
          }
          this.pet.Gender = response.PetSex;
          if (this.pet.BirthDate && this.pet.BirthMonth && this.pet.BirthYear)
            this.pet.BirthDate =
              this.pet.BirthDate +
              "." +
              this.pet.BirthMonth +
              "." +
              this.pet.BirthYear;
          let color = "";
          if (response.PetColor) {
            color = response.PetColor + " ";
          }
          if (!this.pet.PetLostFoundImage) {
            if (parameters.SpeciesID == 1)
              this.pet.PetLostFoundImage = "assets/img/home/lost-animl-bg.png";
            else
              this.pet.PetLostFoundImage = "assets/img/home/homepet_cat.png";
          }
          // else if (this.pet.PetLostFoundImage) {
          //   const img = new Image();
          //   img.src = this.pet.PetLostFoundImage;
          //   // console.log(img);
          //   img.onerror = (err) => {
          //     // console.log(err)
          //     if (parameters.SpeciesID == 1)
          //       this.pet.PetLostFoundImage = "assets/img/home/lost-animl-bg.png";
          //     else
          //       this.pet.PetLostFoundImage = "assets/img/home/homepet_cat.png";
          //   };
          // }
          if (!this.pet.PetPhoto) {
            if (parameters.SpeciesID == 1)
              this.pet.PetPhoto = "assets/img/home/lost-animl-bg.png";
            else
              this.pet.PetPhoto = "assets/img/home/homepet_cat.png";
          }
          else if (this.pet.PetPhoto) {
            const img = new Image();
            img.src = this.pet.PetPhoto;
            img.onerror = () => {
              if (parameters.SpeciesID == 1)
                this.pet.PetPhoto = "assets/img/home/lost-animl-bg.png";
              else
                this.pet.PetPhoto = "assets/img/home/homepet_cat.png";
            };
          }
          let city = "";
          if (response.City) {
            city = response.City;
          }

        } else {
          if (this.petType === "previous") {
            this.isPreviousDisabled = true;
          } else if (this.petType === "next") {
            this.isNextDisabled = true;
          }
        }

        const currentUrl = window.location.href;
        //   this.meta.updateTag({property: 'og:title', content: response.PostTitle});
        //  this.meta.updateTag({property: 'og:image', content: this.petImagePath + response.ImagePath});
        //  this.meta.updateTag({property: 'og:url', content:currentUrl})


      });
      //  this.shareOnFacebook();
    } else {
      this.Pets.GetLostFoundPetDetailsByID(parameters).subscribe((response) => {
        let titleContent = "";
        if (response) {         
          this.pet = response;
          this.petAddress = this.pet.Area;          
          this.pet.IsNeighbourPet = false;
          if (this.pet.MasterSpeciesID == 1) {
            this.pet.customMarker = 'assets/img/h-icon.png';
          }
          else if (this.pet.MasterSpeciesID == 2) {
            this.pet.customMarker = 'assets/img/k-icn.png';
          }
          else {
            this.pet.customMarker = 'assets/img/a-icon.png';
          }

          this.pet.AdditionalInfo = response?.AdditionalInfo?.replace(/(<([^>]+)>)/gi, "");
          this.printPetUrl = environment.apiUrl + environment.PrintPDFURL + this.pet?.LostFoundID;
          this.reunitepet = parameters.OperationTypeID;
          this.qrCodeString = window.location.href;
          this.lat = Number(response.lat);
          this.lng = Number(response.lng);
          this.zoom = 15;
          let subtext = "";
          if (response && response.OperationTypeID == 1) {
            subtext = "Tapt";
          } else if (response && response.OperationTypeID == 2) {
            subtext = "Funnet";
          }

          // let HairType ='';
          if (response.HairType == 1) {
            this.pet.HairType = "Langhåret";
          } else if (response.HairType == 2) {
            this.pet.HairType = "Korthåret";
          }
          if (!this.pet.ShowChipNoToOthers) this.pet.ChipID = "";
          if (response.Gender == 1) {
            this.pet.Gender = "Hann";
          } else if (response.Gender == 2) {
            this.pet.Gender = "Hunn";
          } else if (response.Gender == 0) {
            this.pet.Gender = "Vet ikke";
          }

          let color = "";
          if (response.Color) {
            color = response.Color + " ";
          }
          let city = "";
          if (response.City) {
            city = response.City;
          }
          this.showPrintButton = false;
          const currentUrl = window.location.href;
          //this.meta.updateTag({property: 'og:title', content: response.PostTitle});
          //this.meta.updateTag({property: 'og:image', content: this.petImagePath + response.ImagePath});          
          //this.meta.updateTag({ property: 'og:image', content: currentUrl }, "property='og:image'");
          let currentUser = localStorage.getItem('currentUser')

          if (currentUser) {
            this.currentUserId = JSON.parse(currentUser)["ID"];
            this.showReunitePetButton = this.currentUserId == this.pet.UserLoginID ? true : false
            this.showPrintButton = this.currentUserId == this.pet.UserLoginID ? true : false
            this.alreadyReunite = this.pet.IsReunite ? false : true;
          }
        } else {
          if (this.petType === "previous") {
            this.isPreviousDisabled = true;
          } else if (this.petType === "next") {
            this.isNextDisabled = true;
          }
        }
        this.title.setTitle(this.ShareMessage);

      });
      //   this.shareOnFacebook();       
    }
  };

  goToDetails = (petDetail) => {
    let type;
    let queryParams;
    let encryptedPet_ChipId;
    this.LostFoundPetID = petDetail.LostFoundID;
    var OperationTypeID = petDetail.OperationTypeID;
    localStorage.removeItem('LostFoundPetID');
    localStorage.removeItem('OperationTypeID');
    localStorage.setItem("LostFoundPetID", this.LostFoundPetID);
    localStorage.setItem("OperationTypeID", OperationTypeID);

    if (petDetail.IsNeighbourPet) {
      type = 'registered'
      queryParams = { "ChipID": petDetail.ChipID }
      var ChipID = petDetail.ChipID;
      localStorage.setItem("pet_ChipID", ChipID);
      encryptedPet_ChipId = btoa(queryParams);
      localStorage.setItem("Url_ChipId", petDetail.ChipID);
      localStorage.removeItem('Url_PetId');
    } else {
      type = petDetail.OperationTypeID == 1 ? 'lost' : 'found'
      queryParams = { "PetID": petDetail.LostFoundID }
      encryptedPet_ChipId = btoa(queryParams);
      localStorage.setItem("Url_PetId", petDetail.LostFoundID);
      localStorage.removeItem('Url_ChipId');
    }
    this.scrollTop()

    if (!petDetail.PostTitle) {
      petDetail.PetName = petDetail.MasterSpecies + ' ' + (petDetail.OperationTypeID === '1' ? 'Savnet' : 'Funnet');
      petDetail.PetName = (petDetail.PetName + (petDetail.City ? ' i ' + petDetail.City : '')).trim();
      petDetail.PostTitle = petDetail.PetName.replace(/[&\/\\#,^/!/%+()$~%.'":*?<>{}]/g, "").replace(/\s/g, "_");
    }

    let PostTitle = petDetail.PostTitle.replace(/\s/g, "_");
    this.routeObj.navigate([`savnetfunnet/${type}/${encryptedPet_ChipId}/${PostTitle}`]);
  }

  openModal(event) {
    document.getElementById(
      event.currentTarget.parentElement.nextElementSibling.id
    ).style.display = "flex";
  }

  openDialog(pet: any, title: any): void {
    pet.dialogTitle = title;
    let height = !this.pet?.GDPRStatus ? '520px' : '180px';
    const dialogRef = this.dialog.open(DialogComponent, {
      width: "500px",
      height: height,
      data: pet,
    });
  }

  closeModal(event) {
    document.getElementById(
      event.currentTarget.parentElement.id
    ).style.display = "none";
  }

  shareWithFacebook(id): void {
    let shareUrl = this.detailMessageString + id;
    //shareUrl = 'https://lostfound.staging.dyreid.no/pet-detail?PetID=1099';
    let url = "http://www.facebook.com/sharer.php?u=" + shareUrl;
    let newwindow = window.open(
      url,
      "name",
      "height=500,width=520,top=200,left=300,resizable"
    );
    if (window.focus) {
      newwindow.focus();
    }
  }

  goBack() {
    const page = localStorage.getItem("_page");
    if (page && page === "list_page") {
      this.routeObj.navigate(["/list-pets"], {
        queryParams: { OperationTypeID: 1, radiousDistance: 10 },
      });
    } else if (page && page === "dashboard") {
      this.routeObj.navigate(["/dashboard"]);
    } else if (page && page === "report-found") {
      this.routeObj.navigate(["/report-found"]);
    } else if (page && page === "report-lost") {
      this.routeObj.navigate(["/report-lost"]);
    } else {
      this.routeObj.navigate(["/"]);
    }
  }

  printPDF() {
    // const printContent = document.getElementById("containerID");
    // document.getElementById("qr-code").style.display = 'block';
    // const printRemoveContent = document.getElementById("ThumbnailImageBlockID");
    // const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    // var html = printContent.innerHTML.replace(printRemoveContent.innerHTML, "");
    // // WindowPrt.document.write(printContent.innerHTML);
    // WindowPrt.document.write(html);
    // WindowPrt.document.close();
    // WindowPrt.focus();
    // WindowPrt.print();
    // WindowPrt.close();
    // document.getElementById("qr-code").style.display = 'none';
    this.generatePDF();
  }

  generatePDF() {
    window.open(this.printPetUrl);
  }

  previousItem = () => {
    this.petType = "previous";
    this.getPetDetails();
  };

  nextItem = () => {
    this.petType = "next";
    this.getPetDetails();
  };

  goToBack() {
    history.back();
  }

  onSwipe = (e) => {
    if (e.type === "swiperight") {
      this.previousItem();
    } else {
      this.nextItem();
    }
  };

  shareOnFacebook() {

    const currentUrl = window.location.href;

    const params: UIParams = {
      href: currentUrl,
      method: "share",
    };

    this.fb
      .ui(params)
      .then((res: UIResponse) => console.log("RES : ", res))
      .catch((e: any) => console.log("ERROR : ", e));
  }
  scrollTop = () => {
    const element = document.querySelector('#scrollId');
    element.scrollIntoView({ behavior: 'smooth' });
  }

  errorHandler = (e) => {
    e.target.src = environment.baseUrl + environment.placeholderImg;
  };

  ReunitePet(pet: any) {
    if (pet.OperationTypeID > 2) {
      return false;
    }
    let lostPetId;
    let foundPetId;

    if (pet.OperationTypeID == 1)
      lostPetId = pet.LostFoundID;
    else
      foundPetId = pet.LostFoundID;

    let message = "Bekreft at du vil melde dyret som gjenforent?";
    let flag = confirm(message);

    if (flag) {
      //this.MarkPetAsReunite(lostPetId, foundPetId);
      this.NewMarkPetAsReunite(lostPetId, foundPetId);
    }
  }

  MarkPetAsReunite(PetLostID: any, PetFoundId: any) {
    debugger;
    this.Pets.checkFacebookPost(PetLostID).subscribe(Response => {
      if (Response) {
        //if (confirm("Oppdater Facebook-innlegg?")) {
          let socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
          this.authService.signIn(socialPlatformProvider).then(
            (userData) => {
              debugger;
              this.FBUserid = userData.id;
              this.shortToken = userData.authToken;
              let postData = {
                "PetLostId": PetLostID, "PetFoundId": PetFoundId, "UpdatedBy": this.currentUser.ID
                , "FacebookUserId": this.FBUserid, "ShortLivedToken": this.shortToken
              }
              this.Pets.markPetAsReunited(postData).subscribe(response => {
                if (response.data > 0) {
                  //alert("Dyr markert som gjenforent.");
                  alert("Flott at kjæledyret er kommet hjem.");
                } else {
                  alert(response.error);
                }
              });
            }
          );
        
      } else {
        let postData = { "PetLostId": PetLostID, "PetFoundId": PetFoundId, "UpdatedBy": this.currentUser.ID }
    this.Pets.markPetAsReunited(postData).subscribe(response => {
      if (response.data > 0) {
        //alert("Dyr markert som gjenforent.");
        alert("Flott at kjæledyret er kommet hjem.");
      } else {
        alert(response.error);
      }
    });
      }
    });
    
  }

  back() {
    this.routeObj.navigate(["/"]);
  }

  showGender(item: any) {
    if (item && item.Gender && item.Gender != '' && item.Gender.toLowerCase() != "vet ikke")
      return true;

    return false;
  }
  NewMarkPetAsReunite(PetLostID: any, PetFoundId: any) {
    debugger;
    this.petLostFoundId = PetLostID != 0 && PetLostID != undefined?PetLostID:PetFoundId;
    this.Pets.checkFacebookPost(this.petLostFoundId).subscribe(Response => {
      debugger;
      if (Response) {
        debugger;
        //if (confirm("Oppdater Facebook-innlegg?")) {
          let socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
          this.authService.signIn(socialPlatformProvider).then(
            (userData) => {
              debugger;
              this.FBUserid = userData.id;
              this.shortToken = userData.authToken;
              let postData = {
                "PetLostId": PetLostID, "PetFoundId": PetFoundId, "UpdatedBy": this.currentUser.ID
                , "FacebookUserId": this.FBUserid, "ShortLivedToken": this.shortToken
              }
              this.Pets.markPetAsReunited(postData).subscribe(response => {
                if (response.data > 0) {
                  //alert("Dyr markert som gjenforent.");
                  alert("Flott at kjæledyret er kommet hjem.");
                } else {
                  alert(response.error);
                }
              });
            }
          );
        
      } else {
        let postData = { "PetLostId": PetLostID, "PetFoundId": PetFoundId, "UpdatedBy": this.currentUser.ID }
    this.Pets.markPetAsReunited(postData).subscribe(response => {
      if (response.data > 0) {
        //alert("Dyr markert som gjenforent.");
        alert("Flott at kjæledyret er kommet hjem.");
      } else {
        alert(response.error);
      }
    });
      }
    });
    
  }
}
